import { useMutation } from 'react-query'
import userCourseRatingApi from '../../services/api/user-course-rating'
import useStaleTimes from '../use-stale-times'
import useCacheKeys from '../use-cache-keys'
import useCache from '../use-cache'
import moment from 'moment'

const useUserCourseRatingMutations = ({
    onSuccess = () => {},
    onError = () => {},
    userId,
    ratingId,
    rating,
    feedback,
} = {}) => {
    const staleTimes = useStaleTimes()
    const cacheKeys = useCacheKeys()
    const {
        clearCache
    } = useCache({
        key: cacheKeys.SURVEYS,
        onReload: onSuccess
    })
    const [
        updateCourseRating,
        { isLoading }
    ] = useMutation(() => userCourseRatingApi.update({ userId, ratingId, rating, feedback }), { 
        onSuccess: clearCache,
        onError,
    })

    return {
        updateCourseRating,
        isUpdating: isLoading,
    }
}

export default useUserCourseRatingMutations